import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "file-add",
  "use": "file-add-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"file-add\"><path d=\"M4.707 1L2 3.707V15h7.5a.5.5 0 010 1h-8a.5.5 0 01-.5-.5v-12a.5.5 0 01.146-.354l3-3A.5.5 0 014.5 0h9a.5.5 0 01.5.5v8a.5.5 0 01-1 0V1H4.707z\" /><path d=\"M3 5.5a.5.5 0 01.5-.5H6V2.5a.5.5 0 011 0v3a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5zM14 13v-1.5a.5.5 0 00-1 0V13h-1.5a.5.5 0 000 1H13v1.5a.5.5 0 001 0V14h1.5a.5.5 0 000-1H14z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol